module.exports = __webpack_public_path__ + "static/media/experience.85d6957f.svg";